module.exports = __webpack_public_path__ + "static/media/Thumb_1920x384_JWS_ShareTheLove.fb69f488.jpeg";